<template>
    <div class="row">
        <div class="col-md-12">
            <label>{{ tra.do_you_need_visa_name }} {{ dataObj.visa?.name || tra.visa }}</label>
            <span v-if="postErrors.visa_checker && !visaChecker" class="h6 text-danger">
                ( {{ postErrors.visa_checker[0] }} )
            </span>
            <br />
        </div>

        <div class="col-md-6">
            <div class="form-check form-check-inline mr-0 ml-4">
                <input 
                    :value="visaChecker"
                    @change="$emit('update-visa-checker', $event.target.value)"
                    name="visa_checker" 
                    type="radio"
                    style="height: 20px; width: 20px;" 
                    id="visa-yes" 
                    value="1"
                    :class="(postErrors.visa_checker && !visaChecker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" 
                />
                <label class="form-check-label" for="visa-yes">
                    {{ tra.yes }} 
                    <span class="text-main-color">
                        ({{ dataObj.visa?.price || 0 }}
                        <span class="small text-dark">
                            {{ (dataObj.currency?.code || 'SAR') == 'SAR' ? ' ' : (dataObj.currency?.code || 'SAR') }}
                        </span>)
                    </span>
                </label>
            </div>
        </div>
        <div class="col-md-3">
            <div class="form-check form-check-inline mr-0 ml-4">
                <input 
                    :value="visaChecker"
                    @change="$emit('update-visa-checker', $event.target.value)"
                    name="visa_checker" 
                    type="radio"
                    style="height: 20px; width: 20px;" 
                    id="visa-no" 
                    value="0"
                    :class="(postErrors.visa_checker && !visaChecker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" 
                />
                <label class="form-check-label" for="visa-no">{{ tra.no }}</label>
            </div>
        </div>
        <div v-if="isAdmin == '1'" class="col-md-3">
            <div class="form-check form-check-inline mr-0 ml-4">
                <input 
                    :value="visaChecker"
                    @change="$emit('update-visa-checker', $event.target.value)"
                    name="visa_checker" 
                    type="radio"
                    style="height: 20px; width: 20px;" 
                    id="visa-free" 
                    value="free"
                    :class="(postErrors.visa_checker && !visaChecker ? 'is-invalid' : '') + ' form-check-input mr-0 ml-3 bg-secondary'" 
                />
                <label class="form-check-label" for="visa-free">{{ tra.free }}</label>
            </div>
        </div>

        <div class="col-12">
            <hr class="my-2">
        </div>
    </div>
</template>

<script>
export default {
    name: 'VisaSection',
    props: {
        dataObj: Object,
        visaChecker: [String, Number],
        isAdmin: [String, Number],
        postErrors: Object,
        tra: Object,
    },
    emits: ['update-visa-checker'],
};
</script>